export default "__VITE_ASSET__5417eb47__"